import React, { forwardRef } from "react";
import styled from "styled-components";
import { Entry } from "contentful";
import { ButtonStyle, button } from "../lib/sharedStyles";

export interface CTAProps extends Entry {
  id: string;
  brand: string;
  fields: {
    label: string;
    openInNewWindow: boolean;
    style: ButtonStyle;
    applySmallPillStyling: boolean;
    url: string;
    isModal: boolean;
    modalId: string;
  };
}

const Link = styled.a<{
  $style: ButtonStyle;
  $applySmallPillStyling: boolean;
  $brand: string;
}>`
  ${({ $style, $applySmallPillStyling, $brand }) =>
    button($style, $brand, $applySmallPillStyling)}
`;

const CTA = forwardRef<HTMLAnchorElement, CTAProps>(
  (
    {
      id,
      brand,
      fields: {
        label,
        openInNewWindow,
        style,
        applySmallPillStyling,
        url,
        isModal,
        modalId,
      },
    },
    ref
  ) => {
    const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
      if (isModal) {
        event.preventDefault();
        if (window.location.href.includes('garage')) {
          console.log(`Opening modal with ID: ${modalId}`);
        }
      }
    };

    return (
      <Link
        data-promotion-clicked
        data-cta-text={label}
        data-cta-url={url}
        ref={ref}
        $style={style}
        $applySmallPillStyling={applySmallPillStyling}
        $brand={brand}
        data-cta-style={style}
        data-component-id={id}
        target={openInNewWindow ? "_blank" : "_self"}
        onClick={handleClick}
        href={url}
        {...(isModal
          ? {
              "data-modal-trigger": true,
              "data-modal-id": modalId,
            }
          : {})}
      >
        {label}
      </Link>
    );
  }
);  

export default CTA;
